import { render, staticRenderFns } from "./qirdialog.vue?vue&type=template&id=bdc0f478&scoped=true"
import script from "./qirdialog.vue?vue&type=script&lang=js"
export * from "./qirdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc0f478",
  null
  
)

export default component.exports